// removed by extract-text-webpack-plugin
module.exports = {"cardImage":"CardImage__cardImage__2P5R1"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Common/Card/CardImage/CardImage.scss
// module id = 1633
// module chunks = 0